import { FUNNEL_WEIGHTS } from "../insights/writes.js";

/**
 * Buyers first (D130 of documentation/pr-plans/insights-simplify-plan.md), in the browser: a row's search intent, how
 * ready to buy it is, and the current best search, worked out as the server works them out
 * (OpportunityScorer::buyersFirst()), so the table's sort and Why it ranks agree with the list they were sent and
 * stay so after a fold, an Undo or a re-rank. Nothing scales a score (D147): a row's points are what it shows.
 */

/** A row's search intent: its stage, or not sorted. */
export function intentOf(row) {
    return row?.stage ?? "not_sorted";
}

/** How ready to buy a row's searchers are: its search intent's weight (FUNNEL_WEIGHTS), the most ready the highest. */
export function intentWeight(row) {
    return FUNNEL_WEIGHTS[intentOf(row)] ?? FUNNEL_WEIGHTS.not_sorted;
}

function isScored(row) {
    return typeof row?.rawScore?.value === "number";
}

/**
 * The current best search: the best scored row still to do of the most ready-to-buy search intent that has one, the
 * row that says Current best search under its score. Null when no row still to do has a score.
 *
 * @param {object[]} rows
 * @param {(row: object) => boolean} isOpen whether a row is still to do
 */
export function currentBest(rows, isOpen) {
    let best = null;

    rows.forEach((row) => {
        if (!isScored(row) || !isOpen(row)) {
            return;
        }

        const byIntent = best === null ? 1 : intentWeight(row) - intentWeight(best);

        if (byIntent > 0 || (byIntent === 0 && row.rawScore.value > best.rawScore.value)) {
            best = row;
        }
    });

    return best;
}
